var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 70,
    viewBox: "0 0 60 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.0005 40.0002C60.0005 36.0606 59.2245 32.1595 57.7168 28.5197C56.2092 24.8799 53.9993 21.5728 51.2135 18.787C48.4277 16.0013 45.1205 13.7915 41.4807 12.2838C37.8409 10.7762 33.9397 10.0002 30 10.0002V36.0002C31.9996 36.0002 34.0001 37.9877 34.0001 40.0002H60.0005Z",
    fill: "#05F29B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 19.0001C32.7578 19.0001 35.4885 19.5433 38.0364 20.5986C40.5842 21.654 42.8992 23.2008 44.8492 25.1509C46.7993 27.1009 48.3461 29.4159 49.4015 31.9638C50.4568 34.5116 51 37.2423 51 40.0001H49C49 37.505 48.5085 35.0343 47.5537 32.7291C46.5989 30.4239 45.1993 28.3294 43.435 26.5651C41.6707 24.8008 39.5762 23.4012 37.271 22.4464C34.9658 21.4916 32.4951 21.0001 30 21.0001V19.0001Z",
    fill: "#1B1E59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 68.0002C45.464 68.0002 58 55.4642 58 40.0002C58 24.5362 45.464 12.0002 30 12.0002C14.536 12.0002 2 24.5362 2 40.0002C2 55.4642 14.536 68.0002 30 68.0002ZM30 70.0002C46.5685 70.0002 60 56.5688 60 40.0002C60 23.4317 46.5685 10.0002 30 10.0002C13.4315 10.0002 0 23.4317 0 40.0002C0 56.5688 13.4315 70.0002 30 70.0002Z",
    fill: "#1B1E59"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 45C32.7614 45 35 42.7614 35 40C35 37.2386 32.7614 35 30 35C27.2386 35 25 37.2386 25 40C25 42.7614 27.2386 45 30 45ZM30 43C31.6569 43 33 41.6569 33 40C33 38.3431 31.6569 37 30 37C28.3431 37 27 38.3431 27 40C27 41.6569 28.3431 43 30 43Z",
    fill: "#1B1E59"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 1C20 0.447715 20.4477 0 21 0H39C39.5523 0 40 0.447715 40 1V1C40 1.55228 39.5523 2 39 2H21C20.4477 2 20 1.55228 20 1V1Z",
    fill: "#1B1E59"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34 39.9998C34 39.4475 34.4477 38.9998 35 38.9998H53C53.5523 38.9998 54 39.4475 54 39.9998V39.9998C54 40.5521 53.5523 40.9998 53 40.9998H35C34.4477 40.9998 34 40.5521 34 39.9998V39.9998Z",
    fill: "#1B1E59"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5727 16.9672C47.1345 16.631 47.0518 16.0032 47.3881 15.565L51.9941 9.56231C52.3303 9.12416 52.9581 9.04151 53.3962 9.37772V9.37772C53.8344 9.71393 53.917 10.3417 53.5808 10.7798L48.9748 16.7826C48.6386 17.2207 48.0108 17.3034 47.5727 16.9672V16.9672Z",
    fill: "#1B1E59"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29 10.0002V2.00021H31V10.0002H29Z",
    fill: "#1B1E59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTime);
export default __webpack_public_path__ + "static/media/Icon_Time.221c602adf581e771d5285036c352450.svg";
export { ForwardRef as ReactComponent };